import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Controller } from "react-hook-form";

export default function DateField({ control, watch, errors, setValue }) {
  const [mrDate, setMrDate] = useState(new Date());

  return (
    <div className="row py-3">
      <div className="col-12 col-md-6">
        <p className="mb-1" style={{ fontWeight: 500 }}>
          Date
        </p>
        <Controller
          name="mrDate"
          control={control}
          defaultValue={mrDate}
          render={({ field }) => (
            <ReactDatePicker
              className="form-control"
              selected={field.value}
              onChange={(date) => {
                field.onChange(date);
                setMrDate(date);
              }}
              dateFormat="MMMM dd, yyyy"
            />
          )}
        />
      </div>
    </div>
  );
}
